import(/* webpackMode: "eager" */ "/kingsyard-ssr/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/WholesaleProgramPage/wholesale-form.jsx");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/components/WholesaleProgramPage/wholesaleProgramPage.module.css");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/index.module.css");
